import {
  LayoutDashboard,
  Building2,
  Users,
  Tags,
  Settings,
  Boxes,
  Bird,
  Tally3,
  RotateCcw,
  PiggyBank,
  History,
  Egg,
  UserPlus,
  BookOpen,
} from "lucide-react";
import { AdminLink, OwnerLink } from "./types";

export const adminLinks: AdminLink[] = [
  { name: "Dashboard", href: "/admin", icon: LayoutDashboard },
  { name: "Entreprises", href: "/admin/companies", icon: Building2 },
  { name: "Utilisateurs", href: "/admin/users", icon: Users },
  { name: "Types d'entreprise", href: "/admin/business-types", icon: Tags },
  { name: "Tutoriels", href: "/admin/tutorials", icon: BookOpen },
];

export const ownerLinks: OwnerLink[] = [
  { name: "Tableau de bord", href: "/owner", icon: LayoutDashboard, feature: "dashboard" },
  { name: "Stock", href: "/owner/stock", icon: Boxes, feature: "stock" },
  { name: "Ferme avicole", href: "/owner/poultry", icon: Bird, feature: "poultry", requireFeature: true },
  { name: "Production d'œufs", href: "/owner/egg-production", icon: Egg, feature: "poultry", requireFeature: true },
  { name: "Comptage", href: "/owner/counting", icon: Tally3, feature: "counting" },
  { name: "Retours, Pertes et Crédits", href: "/owner/returns", icon: RotateCcw, feature: "returns" },
  { name: "Historique", href: "/owner/history", icon: History, feature: "history" },
  { name: "Budget", href: "/owner/budget", icon: PiggyBank, feature: "budget" },
  { name: "Fournisseurs", href: "/owner/suppliers", icon: UserPlus, feature: "suppliers" },
  { name: "Paramètres", href: "/owner/settings", icon: Settings, feature: "settings" },
];